module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/unzip_imgs.worker.ad096ef52a7fa1b6c7b4.js");
}
